"use client"
import { useEffect, useRef } from "react"

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideClickCapture = (
  ref: React.MutableRefObject<any>,
  callback: () => void
) => {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callbackRef.current()
      }
    }

    document?.addEventListener?.("mousedown", handleClickOutside, true)
    return () => {
      document?.removeEventListener?.("mousedown", handleClickOutside, true)
    }
  }, [ref])
}
